// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2ZLCM","row":"ProcedureTreatmentSummary_row__1z4W5"};